module.exports = __webpack_public_path__ + "img/img21.8c26fee3.svg";